import moment from "moment/moment";
import { MetricsKey } from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsTypes";
import { convertBytesToMB } from "@/components/pages/common/filters/utils/helpers/unitsConverting";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { metricsLabel } from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsConstants";

export const inlineMetricsHighchartsDataGenerator = (
  metricType: MetricsKey,
  input: { startPoint: string; data: string },
  metricFrequencyValue?: string,
) => {
  const values = input.data.split(",");

  const categories: string[] = [];
  const data: { y: number | null }[] = [];

  const limit = metricFrequencyValue === "7d" ? 7 : values.length;
  const startIndex = values.length - limit;
  const unit = metricFrequencyValue === "24h" ? "hour" : "day";

  const mapOfValues: Record<string, number | null> = {};
  const dateType = metricFrequencyValue === "24h" ? "dateHour" : "date";

  for (let i = startIndex; i < values.length; i++) {
    const newDate = moment(input.startPoint).add(i, unit);

    const point = values[i];
    let value = isNaN(+point) || point === "" ? null : +point;

    if (metricType === "processed_bytes" && value) {
      value = convertBytesToMB(value);
    }

    mapOfValues[formatDate(newDate, { type: dateType })] = value;
  }

  const startPointDate = moment(input.startPoint);
  const now = moment();

  for (let i = 0; i < limit; i++) {
    let newDate = moment();

    if (metricFrequencyValue === "24h") {
      newDate = newDate
        .minute(startPointDate.minute())
        .second(startPointDate.second());
    } else {
      newDate = newDate
        .hour(startPointDate.hour())
        .minute(startPointDate.minute())
        .second(startPointDate.second());
    }

    newDate = newDate.subtract(i, unit);

    if (newDate.isAfter(now)) {
      newDate = now;
    }

    const formattedDate = formatDate(newDate, { type: dateType });

    categories.push(formatDate(newDate, { type: "dateTimeWithComma" }));
    data.push({ y: mapOfValues[formattedDate] ?? null });
  }

  return {
    categories: categories.toReversed(),
    series: [{ name: metricsLabel[metricType], data: data.toReversed() }],
  };
};
